(function (app, ng) {
    app.provider("figEmailer", [function () {
        this.$get = ["$mdDialog", function ($mdDialog) {
            var service = {};

            service.open = function (options) {
                return $mdDialog.show({
                    targetEvent: options.event,
                    templateUrl: "/App/Services/Emailer/template.html",
                    locals: {
                        options: options
                    },
                    controller: emailerController,
                    controllerAs: "$ctrl"
                });
            };

            return service;
        }];
    }]);

    emailerController.$inject = ["$mdDialog", "figToaster", "figToastContainers", "options", "emailApi", "figMessageModal"];

    function emailerController($mdDialog, figToaster, figToastContainers, options, emailApi, figMessageModal) {
        var $ctrl = this;

        ng.extend($ctrl,
        {
            UI: {
                isClosing: false,
                isSending: false
            },
            email: {
                Body: options.body,
                Subject: options.subject,
                Recipients: {
                    To: options.to ? formatArray(options.to) : "",
                    Cc: options.cc ? formatArray(options.cc) : "",
                    Bcc: options.bcc ? formatArray(options.bcc) : ""
                }
            },
            title: options.title,
            secondaryTitle: options.secondaryTitle,
            close: close,
            send: send,
            indent: indent
        });

        function close() {
            $ctrl.UI.isClosing = true;

            return $mdDialog.cancel();
        }

        function error(message) {
            $ctrl.UI.isSending = false;

            return figToaster.showError(message, "bottom center", figToastContainers.get("emailer"), true);
        }

        function send() {
            $ctrl.UI.isSending = true;

            if (!$ctrl.email.Recipients.To.trim())
                return error("You must enter at least one recipient for the email.");

            var email = {
                Recipients: {
                    To: formatString($ctrl.email.Recipients.To),
                    Cc: formatString($ctrl.email.Recipients.Cc),
                    Bcc: formatString($ctrl.email.Recipients.Bcc)
                },
                Body: $ctrl.email.Body.replace(/[\r\n]/g, "<br />").replace(/\n/g, "<br />").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;"),
                Subject: $ctrl.email.Subject
            };

            return emailApi.createAndSend(email).then(function () {
                $ctrl.UI.isClosing = true;

                return $mdDialog.hide().then(function () {
                    return figMessageModal.show("Your email was sent successfully.");
                });
            });
        }

        function indent(e, text) {
            e.preventDefault();

            var start = e.target.selectionStart;
            var end = e.target.selectionEnd;

            e.target.value = e.target.value.substring(0, start) + "\t" + e.target.value.substring(end);
            
            e.target.selectionStart = e.target.selectionEnd = start + 1;
        }

        function formatArray(arr) {
            var text = "";

            for (var i = 0; i < arr.length; i++) {
                text += arr[i];

                if (i !== arr.length - 1) text += ", ";
            }

            return text;
        }

        function formatString(text) {
            if (!text.trim()) return [];

            var arr = text.split(",");

            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].trim();
            }

            return arr;
        }
    }
})(window.app, window.angular); // jshint ignore:line